// dashboard — am. Part of the am i18n bundle; merged by ./index.js

export default {
  back: '← ተመለስ',
  createAccount: 'መለያ ፍጠር →',
  creating: 'መለያ በመፍጠር ላይ...',
  companyNameLabel: 'የኩባንያ / ንግድ ስም *',
  businessTypeLabel2: 'የንግድ አይነት',
  locationLabel: 'አካባቢ (ከተማ)',
  websiteLabel: 'ድህረ ገጽ (አማራጭ)',
  businessLicenseLabel: 'የንግድ ፈቃድ ቁጥር *',
  tinLabel: 'TIN ቁጥር',
  elmisLabel: 'E-LMIS ምዝገባ',
  passwordMismatch: 'የይለፍ ቃሎቹ አይዛመዱም።',
  myDashboardTitle: 'የእኔ ዳሽቦርድ',
  underReview: 'መለያ በግምገማ ላይ',
  underReviewMsg: 'ቡድናችን የንግድ መረጃዎን እየገመገመ ነው። በ1-2 የስራ ቀናት ውስጥ እናገኝዎታለን።',
  businessTab: '🏢 የንግድ መረጃ',
  socialTab: '📱 ሶሻል እና ተጨማሪ',
  passwordTab: '🔒 የይለፍ ቃል',
  saveChanges: 'ለውጦችን አስቀምጥ',
  saving: 'በማስቀመጥ ላይ...',
  profileUpdated: 'መገለጫ በተሳካ ሁኔታ ተዘምኗል።',
  passwordChanged: 'የይለፍ ቃል በተሳካ ሁኔታ ተቀይሯል።',
  currentPassword: 'የአሁኑ የይለፍ ቃል',
  newPassword: 'አዲስ የይለፍ ቃል',
  confirmNewPassword: 'አዲስ የይለፍ ቃል ያረጋግጡ',
  confirmPayment: 'ክፍያ አረጋግጥ',
  rejectPayment: 'ክፍያ ውድቅ አድርግ',
  requestDelivery: 'ዴሊቨሪ ጠይቅ',
  removedByAdmin: 'በአስተዳዳሪ ተወግዷል',
  myStoreTab: '🛍️ የእኔ መደብር',
  myOrdersTab: '📦 የእኔ ትዕዛዞች',
  myPurchasesTab: '🛒 ግዢዎቼ',
  productName: 'የምርት ስም',
  productDescription: 'መግለጫ',
  productPrice: 'ዋጋ (ብር)',
  productCategory: 'ምድብ',
  productStock: 'የክምችት ብዛት',
  productNotFound: 'ምርቱ አልተገኘም።',
  businessInformation: 'የንግድ መረጃ',
  yearEstablished: 'የተቋቋመበት ዓመት',
  numberOfEmployees: 'የሰራተኞች ብዛት',
  socialMediaExtra: 'ሶሻል ሚዲያ እና ተጨማሪ ዝርዝሮች',
  instagramHandle: '📸 ኢንስታግራም ማለፊያ',
  tiktokHandle: '🎵 ቲክቶክ ማለፊያ',
  telegramLabel: '✈️ ቴሌግራም',
  facebookPage: '📘 ፌስቡክ ገጽ',
  servicesNeeded: 'የሚፈልጉ አገልግሎቶች',
  servicesNeededPlaceholder: 'ለምሳሌ፦ የሶሻል ሚዲያ አስተዳደር፣ ይዘት መፍጠር...',
  aboutYourBusiness: 'ስለ ንግድዎ',
  aboutYourBusinessPlaceholder: 'ስለ ንግድዎ ይንግሩን...',
// Order labels,
  orderNumber: 'ትዕዛዝ #',
  bank: 'ባንክ',
  proof: 'ማስረጃ',
  screenshot: 'ስክሪንሾት',
  ref: 'ማጣቀሻ',
// ── User dashboard ───────────────────────────────────────────────────────,
  dashPaymentTab: '💳 ክፍያ',
  dashEmailInvalid: 'ትክክል የኢሜይል አድራሻ ያስገቡ።',
  dashPhoneInvalid: 'የስልክ ቁጥር 9 አሃዞች ማለት አለበት።',
  dashUpdateFailed: 'ለውጦችዎን ማስቀመጥ አልተቻለም። እንደገና ይሞክሩ።',
  dashPasswordChangeFailed: 'የይለፍ ቃልዎን መቀየር አልተቻለም። እንደገና ይሞክሩ።',
  dashFieldRequired: (f) => `${f} ማስገባት አለበት።`,
  dashPriceInvalid: (f) => `${f} ከዜሮ በላይ መሆን አለበት።`,
  dashStockInvalid: (f) => `${f} ከዜሮ በታች መሆን አይችልም።`,
  dashSaveProductFailed: 'ምርቱን ማስቀመጥ አልተቻለም። እባክዎ ሁሉንም መስክ ያረጋግጡ።',
  dashDeleteFailed: 'ሰርዝ አልተቻለም። እንደገና ይሞክሩ።',
  dashDeletePhotoFailed: 'ፎቶውን ሰርዝ አልተቻለም። እንደገና ይሞክሩ።',
  dashConfirmFailed: 'ክፍያውን ማረጋገጥ አልተቻለም። እንደገና ይሞክሩ።',
  dashRejectFailed: 'ክፍያውን ውድቅ ማድረግ አልተቻለም። እንደገና ይሞክሩ።',
  dashBankAccountRequired: 'የሂሳብ ቁጥር ያስገቡ።',
  dashBankAdded: 'የክፍያ ዘዴው በተሳክነት ተጨምሯል።',
  dashBankAddFailed: 'የክፍያ ዘዴውን መጨምር አልተቻለም። እንደገና ይሞክሩ።',
  dashSelectCategory: 'ምድብ ይምረጡ',
  dashSubcategory: 'ንዑስ ምድብ',
  dashSelectSubcategory: 'ንዑስ ምድብ ይምረጡ',
  dashAvailableColors: 'ያለውት ቀለሞች',
  dashColorsHint: 'ለማቅረብ የሚችሉትን ቀለሞች ለመምረጥ አንቀጾችን ይጫኑ።',
  dashAllColors: 'በሁሉም ቀለሞች ይገኛል',
  dashProductPhotos: 'የምርት ፎቶዎች',
  dashProductPhotosHint: 'እስከ 5 ፎቶዎች። መጀመሪያው ለስር ያገለግላል።',
  dashUploadingPhotos: 'ፎቶዎች በመጫን ላይ...',
  dashStockLabel: (n) => `በክምችት ላይ: ${n}`,
  dashPaymentMethods: 'የክፍያ መንገድ',
  dashPaymentMethodsDesc: 'ደምበኞች ክፍያታቸውን የሚልኩበትን የባንክ ሂሳብ ያስገቡ። መረጃው በክፍያ ጊዜ ይታያል።',
  dashAddBankAccount: 'የባንክ ሂሳብ ጨምር',
  dashBankLabel: 'ባንክ',
  dashAccountNumber: 'የሂሳብ ቁጥር',
  dashAccountNumberPh: 'ለምሳሌ 1000123456789',
  dashAccountNameOptional: 'የሂሳብ ስም (አማራጭ)',
  dashAccountNamePh: 'ለምሳሌ የእኔ ድርጅት አድራሻ',
  dashAddPaymentMethod: 'ሂሳቡን አስቀምጥ',
  dashYourAccounts: 'የእርስዎ ሂሳቦች',
  dashNoBankAccounts: 'እስካሁን የክፍያ ዘዴ አልተጨምረም።',
  dashAccountLabel: (n) => `ሂሳብ: ${n}`,
  dashStatusPending: 'በግምገማ ላይ',
  dashStatusActive: 'የተረጋገጠ',
  dashStatusSuspended: 'ተቋርጧል',
  dashOrderStatusPending: 'ክፍያ በመጠበቅ ላይ',
  dashOrderStatusConfirmed: 'ተረጋጅቷል',
  dashOrderStatusRejected: 'ውድቅ ተደርጓል',
  dashStatusUnknown: (s) => s,
};

